import React from "react";
import "@fontsource/chivo";

const ContactForm = () => {
  return (
    <section className="max-w-3xl mx-auto mt-20 px-4">
      {/* Section Title */}
      <h2 className="text-3xl sm:text-4xl text-center font-[chivo] text-[#009FB7] mb-12">
        Scrivici un messaggio
      </h2>

      <form className="space-y-6 text-left font-[chivo]">
        {/* Nome + Cognome */}
        <div className="grid sm:grid-cols-2 gap-6">
          <div>
            <label className="block mb-1 font-semibold text-[#333]">
              Nome <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              required
              className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#009FB7]"
              placeholder="Mario"
            />
          </div>
          <div>
            <label className="block mb-1 font-semibold text-[#333]">
              Cognome <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              required
              className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#009FB7]"
              placeholder="Rossi"
            />
          </div>
        </div>

        {/* Email */}
        <div>
          <label className="block mb-1 font-semibold text-[#333]">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            required
            className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#009FB7]"
            placeholder="esempio@email.com"
          />
        </div>

        {/* Telefono */}
        <div>
          <label className="block mb-1 font-semibold text-[#333]">
            Telefono
          </label>
          <input
            type="tel"
            className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#009FB7]"
            placeholder="+39 333 123 4567"
          />
        </div>

        {/* Messaggio */}
        <div>
          <label className="block mb-1 font-semibold text-[#333]">
            Commento o messaggio <span className="text-red-500">*</span>
          </label>
          <textarea
            required
            rows="5"
            className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#009FB7]"
            placeholder="Scrivi qui il tuo messaggio..."
          ></textarea>
        </div>

        {/* Submit Button */}
        <div className="pt-4 pb-16 text-center">
          <button
            type="submit"
            className="px-10 py-2 bg-[#009FB7] text-white rounded-full hover:bg-[#007c91] transition duration-300"
          >
            Invia
          </button>
        </div>
      </form>
    </section>
  );
};

export default ContactForm;
